
import React from 'react';
import styled, { css } from 'styled-components'

const sizes = {
  desktop: 992,
  tablet: 768,
  phone: 576
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] / 16}em) {
      ${css(...args)}
    }
  `;

  return acc
}, {});

const Div = styled('div')`
  color: ${props => props.color ? props.theme.colors[props.color] : props.theme.colors.secondary };
  font-size: ${ props => props.theme.fonts[props.size].fontSize };
  line-height: ${ props => props.theme.fonts[props.size].lineHeight };
  font-weight: lighter;
  font-style: ${ props => props.emphasis ? 'italic' : 'inherit' }
  
  ${media.phone`font-size: ${ props => props.theme.fonts[props.size].mobileFontSize };`}
  ${media.phone`line-height: ${ props => props.theme.fonts[props.size].mobileLineHeight };`}
`;


export const Text = (props) => {
  return (<Div className={ props.className }
               size={ props.size }
               color={ props.color }
               dangerouslySetInnerHTML={ { __html: props.content } }
               tag={ props.tag }
               emphasis={ props.emphasis }
          >
            { props.children }
          </Div>)
};

Text.defaultProps = {
  size: 'large'
};

Text.propTypes = {

};



// WEBPACK FOOTER //
// ./src/components/Text/Text.js